import React, { FC, ReactElement, useContext } from 'react'
import { ManageCustomRoles } from '../../../../../i18n'
import CLanguageHandler from '../../../../NonReact/Languages/LanguageHandler'
import Button from '../../../Common/Components/Button'
import { DocTopic } from '../../../Common/Constants/Documentation'
import { LanguageContext, ServletPathContext } from '../../../Common/Contexts'
import { ServletPathContextType } from '../../../Common/Contexts/ServletPathContext'
import { openHelpPortalByTopic } from '../../../Common/Utils'

type Props = {
    closeModal: () => void
}

/**
 * Footer actions for the customise role popup.
 *
 * @param closeModal - Close modal function.
 */
export const FooterActions: FC<Props> = ({ closeModal }: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler
    const servletPath: ServletPathContextType = useContext(ServletPathContext)

    const handleHelpClick = (): void => {
        if (servletPath) {
            openHelpPortalByTopic(servletPath, DocTopic.ADMIN_MANAGE_USER_ROLES)
        }
    }

    return (
        <div className='tabs-footer'>
            <Button
                label={language.get(ManageCustomRoles.ManageCustomRoles_Help)}
                onClick={handleHelpClick}
                type='button'
            />
            <Button label={language.get(ManageCustomRoles.ManageCustomRoles_Save)} type='submit' />
            <Button
                isOutlined
                label={language.get(ManageCustomRoles.ManageCustomRoles_Cancel)}
                onClick={closeModal}
                type='button'
            />
        </div>
    )
}
